/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';
import classNames from 'classnames';

import { translate as t } from '../../../translations';

/**
 * Renders a choice element for `<Select />`.
 *
 * @return {Component} The Choice component.
 */
const Choice = ({ ChoiceComponent, hasSelectedStyle, id, isError, isSelected, onClick, value }) => {
    return (
        <li
            className={classNames('dropdown-link custom-select__choice', {
                'custom-select__choice--is-active': isSelected && hasSelectedStyle,
            })}
            id={id}
            onClick={onClick}
        >
            {ChoiceComponent && (
                <ChoiceComponent isError={isError} isSelected={isSelected} label={value.label} value={value.value} />
            )}
            <span className="custom-select__choice-label">{t(value.label)}</span>
        </li>
    );
};

Choice.defaultProps = {
    ChoiceComponent: null,
    hasSelectedStyle: false,
    isError: false,
    isSelected: false,
};

export { Choice };
